export default {
    
    formatName(chiropractor) {
        return chiropractor.firstName + " " + chiropractor.lastName;
    }

}